import React from 'react'
import Loading from './Loading'

export default function LoadingImg() {
    return (
        <div className='w-full h-full flex items-center justify-center '>
            <Loading 
                isDefault={false}
                message=''
                spinH={'w-5 h-5'}
            />
        </div>
    )
}
